new WOW().init();
var wows = document.getElementsByClassName('wow')
for (i = 0; i < wows.length; i++){
  wows[i].style.visibility ='hidden';
}

(function($) {


  $(document).ready(function() {
	  
	  $(document).on("click", '.btn-scroll-down', function(event) {
			event.preventDefault();
			console.log("test2ddd");
			var $anchor = $(this);
			$('html, body').stop().animate({
            	scrollTop: $($anchor.attr('href')).offset().top-50
        		}, 500, 'swing');
				event.preventDefault();
    	});
		
        $('img.svg').each(function(){
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function(data) {
                // Get the SVG tag, ignore the rest
                
                               
                var $svg = jQuery(data).find('svg');
				$svg = $svg.remove('style');
                
//                 console.log( $svg );
                

                // Add replaced image's ID to the new SVG
                if(typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if(typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass+' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');
               

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');
        }); // img.svg
        
        
        $('.single-job #career-subject').val( 'Ogłoszenie: ' + $('.type-job h1').text() );


		// if( $( window ).width() < 767 ) {

	        // $('.dropdown > a').attr({
		        // 'href': '#',
		        // 'data-toggle': 'dropdown'
	        // });
        
        // }
        
        
		$('.file-cv input').change(function () {
			var $txt = $( this ).parents('.file-cv').find('.txt');
			var $this = $( this );
			
			
			$txt.html( $this.val() ? $this.val().replace(/C:\\fakepath\\/i, '') : 'Wstaw załącznik' )
			
			console.log( $this );
		});
		
		
		
		$('.tab-content a[href$=".jpg"]').click(function (event) {
			event.preventDefault();
			
			var $this = $( this );
			
			var url = $this.attr('href');
			lity( url );
			
		});


		$('.go-to-up').click(function(event) {
			event.preventDefault();
			
			
			var body = $("html, body");
			body.stop().animate({
				scrollTop: 0
			}, 500, 'swing');
			
			
			return false;
		});
		
		
		lightbox.option({
		  'albumLabel':  "%1/%2"
		});
		
		
		
		
		$('#newsletter').submit(function (event) {
			event.preventDefault();
			
			var data = $( this ).serialize();
			
			$.post( v.ajaxurl, data, function (data) {
				var info = $('#newsletter_modal');
				if( data.status ) {
					info.find('.title').text('Dziękujemy!');
					info.find('.text').text('Pomyślnie zapisałeś się do newslettera Scandagra Polska.');
					info.modal('show');
				} else {
					info.find('.title').text('Błąd');
					info.find('.text').text('Wystąpił błąd, prosimy spróbować poźniej');
					info.modal('show');
				}
			});
			
		});
		
		var bodyWidth = $( window ).width();
		if( bodyWidth > 1200) {
			var $halfslider_animation = "slide";
		} else {
			var $halfslider_animation = "fade";
		}   
		
		if($halfSliders.length > 0)
		{
			for(var i = 0; i < $halfSliders.length; i++)
			{
				var thisSlider = $halfSliders[i];
				$('.halfslider' + thisSlider).flexslider({
					animation: $halfslider_animation,
					slideshowSpeed: 4000, 
					animationSpeed: 700, 
					pauseOnHover: false,
					touch: true,
					smoothHeight: true,
					controlsContainer: $(".nav-container-halfslider"),
					after:  function(slider){
						 
						var current = slider.find(".flex-active-slide");
						
						var currentContent = current.data("from_slide");
						
						$(currentContent).css("opacity", "1");
						$(currentContent).html(current.data("slide_text"));  
						slider.flexslider('pause');
						slider.flexslider('play');
					},
					before:  function(slider){
						var current = slider.find(".flex-active-slide");
						var currentContent = current.data("from_slide");
						 
						
						if(!slider.hasClass("no-animation"))
							$(currentContent).css("opacity", "0");
						
					}, 
					start: function(slider){
						var current = slider.find(".flex-active-slide");
						var currentContent = current.data("from_slide"); 
						$(currentContent).html(current.data("slide_text"));  
					}
				  });
 
			} 
			$(".half-prev").click(function(e) {
				e.preventDefault(); 
				var currentContent = $(this).data("from_slide");
				console.log(currentContent);
				$('.halfslider'+ currentContent).flexslider('prev');
				
			});
			$(".half-next").click(function(e) { 
				e.preventDefault(); 
				var currentContent = $(this).data("from_slide");
				 
				$('.halfslider'+ currentContent).flexslider('next');
				
			});
		}
		
		
		
		$(".search-form button").click(function(e) {
			var $field = $(".search-field");
			if($field.css('opacity') == "0") {
				$field.css('opacity', "1");
				$field.css('width', "130px");
				e.preventDefault();
			}
			if($field.val() == "")
			{
				e.preventDefault();
			}
		});
		 $(window).scroll(function() {
			//	fixedMenu();
			});		
				
			//fixedMenu();	
			function fixedMenu()
			{
				var windowpos = $(window).scrollTop();
			 
				var $menu = $(".navbar-fixed-top"); 
				 
				if( $menu.length != 0 )
				{ 
					if(windowpos > 0)
					{   
						$menu.addClass("sections-menu-stick");
						 
					} else {
						$menu.removeClass("sections-menu-stick");
						 
					}
				}
	 
			}
		var $offtop = 190;
		var $offbottom = 280;
		if( $( window ).width() < 1649 ) {
			var $offtop = 140;
			var $offbottom = 280;
		}
		if( $( window ).width() > 992 ) {
			$('.affix-sidemenu').affix({
			  offset: {
				top: $offtop,
				bottom: $offbottom
			  }
		   });
		}
		$('#nav-expander').on('click',function(e){
      		e.preventDefault();
      		$('body').toggleClass('nav-expanded');
      	});
      	$('.nav-expander-close').on('click',function(e){
      		e.preventDefault();
      		$('body').removeClass('nav-expanded');
      	});
		
  });
  
	 

})(jQuery);





var Slider = (function($)
{
	var _public = {
		
		slider: function()
		{
			$('.slider-section').flexslider({
				controlNav: true,
				directionNav: false,  
				slideshowSpeed: 4000, 
				after:  function(slider){
 
						slider.flexslider('pause');
						slider.flexslider('play');
					},
			});
			
			$('.slider-products').flexslider({
				controlNav: true,
				directionNav: false,  
				animation: "slide", 
			});
			
			$('.text-slider').flexslider({
				controlNav: true,
				directionNav: false,
				smoothHeight: true,
				prevText: '',
				nextText: '',
			});
			
			$('.product-slider').flexslider({

				directionNav: false,
				manualControls: ".product-thumbnails li",
				slideshow: true,
// 				smoothHeight: true,
			});
		},
		
		init: function()
		{
			$( document ).ready( _public.slider );
		}
	}
	
	
	return _public;
}(jQuery)).init();


